import { render } from "./newsDetail.vue?vue&type=template&id=07876e9e&scoped=true"
import script from "./newsDetail.vue?vue&type=script&lang=js"
export * from "./newsDetail.vue?vue&type=script&lang=js"

import "./newsDetail.vue?vue&type=style&index=0&id=07876e9e&lang=css"
import "./newsDetail.vue?vue&type=style&index=1&id=07876e9e&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07876e9e"]])

export default __exports__